import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { ErrorFormMessage } from '../components/ErrorFormMessage';
import { useHistory } from 'react-router-dom';
import ReactLoader from '../../../../components/Loader';
import { Row, Input, Col, Form } from 'reactstrap';
import { toast } from 'react-toastify';
import ReactButton from '../../../../components/Buttons/ReactButton';
import BranchService from '../service';

export const CreateBranchModal = ({ show, setIsModalOpen, id, setId }) => {
  const { handleSubmit, control, errors } = useForm();

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);

  const errorFormMessage = (message) => <ErrorFormMessage message={message} />;

  useEffect(() => {
    console.log(id);
    if (id) {
      setIsUpdate(true);
      getSingleBrach(id);
    } else {
      setIsUpdate(false);
    }
  }, [id]);

  async function getSingleBrach(id) {
    setIsLoading(true);

    await BranchService.get(`${id}`)
      .then((res) => {
        setData(res.data.data);

        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        toast.error('Erro ao carregar dados da filial.');
        setIsLoading(false);
      });
  }

  const onSubmit = (e) => {
    if (isUpdate) {
      BranchService.put(`${id}`, e)
        .then(() => {
          history.push('/admin/branch/list/');
          toggleModal();
          toast.success('Filial editada com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
        })
        .catch((err) => {
          console.log(err);
          toast.error('Erro ao editar filial.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      console.log(e);
      BranchService.post('', e)
        .then(() => {
          history.push('/admin/branch/list/');
          toggleModal();
          toast.success('Filial cadastrado com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
        })
        .catch((err) => {
          console.log(err);
          toast.error('Erro ao cadastrar filial.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!show);
    setId(false);
  };

  const onError = (errors) => {
    console.log(errors);
    toast.error('Preencha os campos obrigatórios!', {
      autoClose: 3000,
      closeOnClick: true
    });
  };

  return (
    <DefaultModal
      showCloseButton={false}
      modalContainerClasses=""
      title={isUpdate ? 'Editar Filial' : 'Cadastrar Filial'}
      show={show}
      onModalToggle={setIsModalOpen}
    >
      {isLoading ? (
        <Row className="justify-content-md-center">
          <ReactLoader />
        </Row>
      ) : (
        <Form onSubmit={handleSubmit(onSubmit, onError)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Nome</label>
              <Controller
                as={<Input />}
                rules={{ required: 'O nome é obrigatório!' }}
                control={control}
                name="nome"
                defaultValue={isUpdate ? data.nome : ''}
              />
              <ErrorMessage
                errors={errors}
                name="nome"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Empresa</label>
              <Controller
                as={<Input />}
                defaultValue={isUpdate ? data.empresa : ''}
                control={control}
                rules={{ required: 'A Empresa é obrigatória!' }}
                name="empresa"
              />
              <ErrorMessage
                errors={errors}
                name="empresa"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>

          <Row className="md-3" style={{ marginLeft: '0' }}>
            <ReactButton
              btnColor="confirmation"
              // onClick={() => {
              //   products.map((product) => {
              //     if (typeof product.value == 'string') {
              //       product.value = parseFloat(product.value.replace(',', '.'));
              //     }
              //   });

              //   setData([...data, ...products]);

              //   toggleModal();
              // }}
            >
              Salvar
            </ReactButton>
            <ReactButton
              btnColor="cancelation"
              onClick={() => {
                toggleModal();
              }}
            >
              Cancelar
            </ReactButton>
          </Row>
        </Form>
      )}
    </DefaultModal>
  );
};
